import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import fetchProducts from '../../../services/layer';
import { FAST_TIMER } from '~/const/timers';

function timer() {
  return _timer.apply(this, arguments);
}

function _timer() {
  _timer = _asyncToGenerator(function* () {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, FAST_TIMER);
    });
  });
  return _timer.apply(this, arguments);
}

export default {
  fetchProducts(store, payload) {
    var _this = this;

    return _asyncToGenerator(function* () {
      store.commit(types.SET_LOADING_LAYER, true);
      const currentState = store.state;

      if (payload.security) {
        yield timer();
      }

      if (payload.payload !== currentState.latest) {
        return;
      }

      let data = yield fetchProducts(_this, payload.payload);

      if (payload.payload !== currentState.latest) {
        return;
      }

      store.commit(types.SET_LAYER_PRODUCTS, data);
      data = null;
      store.commit(types.SET_LOADING_LAYER, false);
    })();
  },

  resetProducts(_ref) {
    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      commit(types.RESET_LAYER_PRODUCTS, []);
    })();
  },

  setCurrentLayer(store, payload) {
    return _asyncToGenerator(function* () {
      let data = payload;
      store.commit(types.SET_CURRENT_LAYER, data);
      data = null;
    })();
  },

  appendItems(store, payload) {
    return _asyncToGenerator(function* () {
      store.commit(types.APPEND_ITEMS, payload);
    })();
  }

};